import React, { useState, useEffect } from "react";
import { Grid, makeStyles, ThemeProvider } from "@material-ui/core";
import styles from "./EventsScreen.styles";
import theme from "../Login/LoginSreen.breakpoints";
import EventsTable from "../../components/EventsTable/EventsTable";
import AddEventWindow from "../../components/ModalWindows/Events/AddEventWindow";
import "date-fns";
import { shop } from "../../utils/newApi";
import ErrorSnackBar from "../../components/Snackbar/ErrorSnackBar";
import CircularProgress from "@material-ui/core/CircularProgress";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import StyledFormTextField from "../../components/common/textFields/StyledFormTextField";
import TablePagination from "@material-ui/core/TablePagination";
import TablePaginationActions from "../../components/common/pagination/TablePaginationActions";
import ListHeader from "../../components/common/ListHeader";

import { ERROR_MESSAGES } from "../../constants/dictionary";

const useStyles = makeStyles(styles);

const EventsScreen = () => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [events, setEvents] = useState([]);
  const [eventsCopy, setEventsCopy] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState(false);
  const [errorText, setErrorText] = useState("");
  const matches = useMediaQuery(theme.breakpoints.down("sm"));
  const [page, setPage] = React.useState(
    localStorage.getItem("currentEventsTablePage")
      ? Number(localStorage.getItem("currentEventsTablePage"))
      : 0
  );
  const [rowsPerPage, setRowsPerPage] = React.useState(
    localStorage.getItem("currentEventsTableRowsPerPage")
      ? Number(localStorage.getItem("currentEventsTableRowsPerPage"))
      : 10
  );

  const handleError = (text) => {
    setError(true);
    setErrorText(text);
  };

  useEffect(() => {
    shop.events
      .all()
      .then((res) => {
        const sorted = res.data ? res.data.sort((a, b) => b.id - a.id) : [];
        setEvents(sorted);
        setEventsCopy(sorted);
        setIsLoaded(true);
      })
      .catch((err) => {
        handleError(ERROR_MESSAGES.COULD_NOT_CONNECT_TO_SERVER);
      });
  }, [open]);

  const handleChange = (e) => {
    if (e.target.value !== "") {
      const res = eventsCopy.filter((event) => {
        return (
          event.title &&
          event.title.toLowerCase().startsWith(e.target.value.toLowerCase())
        );
      });
      setEvents(res);
      setPage(0);
    } else {
      setEvents(eventsCopy);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <ThemeProvider theme={theme}>
      {isLoaded ? (
        <Grid container>
          <ListHeader
            variant="title-add-search"
            title="Lista Wydarzeń"
            handleAdd={() => setOpen(true)}
            searchComponent={
              <StyledFormTextField
                InputLabelProps={{ classes: { root: classes.label } }}
                name="name"
                fullWidth={matches}
                label="Szukaj wydarzenia"
                variant="outlined"
                shrink="true"
                onChange={(e) => handleChange(e)}
              />
            }
          />
          <Grid container>
            <Grid item xs={12} align="center">
              <EventsTable
                events={events}
                setEvents={setEvents}
                eventsCopy={eventsCopy}
                handleError={handleError}
                page={page}
                rowsPerPage={rowsPerPage}
              />
              <TablePagination
                rowsPerPageOptions={[10, 15, 20, 50]}
                component="div"
                count={events.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignContent: "center",
                }}
                classes={{
                  toolbar: classes.toolbar,
                  caption: classes.caption,
                }}
                labelRowsPerPage={"Ilość wierszy na stronę"}
                labelDisplayedRows={({ from, to, count }) => {
                  return `${from}–${to} z ${
                    count !== -1 ? count : `więcej niż ${to}`
                  }`;
                }}
              />
            </Grid>
            <AddEventWindow
              isOpen={open}
              close={() => setOpen(false)}
              handleError={handleError}
              setEvents={setEvents}
            />
          </Grid>
        </Grid>
      ) : (
        <div className={classes.container}>
          <CircularProgress color="secondary" className={classes.loader} />
        </div>
      )}
      <ErrorSnackBar
        open={error}
        text={errorText}
        close={() => setError(false)}
      />
    </ThemeProvider>
  );
};

export default EventsScreen;
